import CreateRestaurant from "./createRestaurant";

export default CreateRestaurant;
